export default [
  {
    title: "Artist Categories",
    description:
      "Level up your events with outstanding performers. From musicians and singers to DJs, comedians, speakers, and emcees—MakeMyShows helps you book the perfect artist with ease.",
    items: [
      {
        image: "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/singer.webp",
        name: "Singer",
      },
      {
        image: "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/music_band.avif",
        name: "Music Band",
      },
      {
        image: "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/dj.webp",
        name: "DJ",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/comedian.jpg",
        name: "Comedian",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/dancer.jpeg",
        name: "Dancer",
      },
      {
        image: "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/emcee.jpeg",
        name: "EMCEE",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/speaker.jpg",
        name: "SPEAKER",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/magician.avif",
        name: "MAGICIAN",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/devotional_singer.webp",
        name: "DEVOTIONAL SINGER",
      },
    ],
  },

  {
    title: "Book Live Artists",
    description:
      "Explore our curated artists—musicians, bands, singers—perfect for making your event memorable with MakeMyShows.",
    items: [
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist1.jpeg",
        name: "RRL (2504)",
        bio: "SINGER, Delhi",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist3.jpeg",
        name: "SSL BAND (2405)",
        bio: "SUFI BAND, Delhi",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist2.jpeg",
        name: "SL (2406)",
        bio: "SINGER, Delhi",
      },

      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist4.jpeg",
        name: "AS (2407)",
        bio: "ANCHOR, Mumbai",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist5.jpeg",
        name: "NCR Live (2311)",
        bio: "BOLLYWOOD BAND, Mumbai",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist6.jpg",
        name: "GA (2344)",
        bio: "DEVOTIONAL, Mumbai",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist7.jpg",
        name: "RJ (2306)",
        bio: "DJ PRAKASHAN, NCR",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/artist8.jpg",
        name: "DJM (2371)",
        bio: "DJ, GURGAON",
      },
    ],
  },

  {
    title: "Book Live Artists For Any Event",
    description:
      "Make your event truly unforgettable with MakeMyShows’ curated live artist bookings—featuring the best performers for every occasion.",
    items: [
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/private_event.jpg",
        name: "Private Event",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/house_party.jpg",
        name: "House Party",
      },
      {
        image: "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/cafes.jpg",
        name: "Cafes & Lounges",
      },
      {
        image: "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/hotel.jpg",
        name: "Hotels & Villas",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/wedding.jpg",
        name: "Wedding",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/corporate_event.jpg",
        name: "Corporate Event",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/social_event.jpg",
        name: "Social Event",
      },
      {
        image:
          "https://makemyshows-assets.s3.ap-south-1.amazonaws.com/virtual_event.jpg",
        name: "Virtual Event",
      },
    ],
  },
];
